// MixedPricebookBadge — marks an opportunity whose lines come from more than one
// pricebook (owner 2026-10-20). The add-products window lets each batch pick its
// own pricebook, so one opportunity can hold e.g. RESELLER and standard lines. A
// pricebook-scoped validation exemption never covers such an opportunity, so the
// user sees why here instead of only at close. Renders nothing unless mixed.
import React, { useEffect, useState } from 'react';
import config from '../config/config';

const API_BASE = config.api.baseUrl;

export default function MixedPricebookBadge({ opportunityId, refreshKey }) {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    if (!opportunityId) { setSummary(null); return undefined; }
    let alive = true;
    fetch(`${API_BASE}/api/validations/opportunity/${encodeURIComponent(opportunityId)}/pricebooks`)
      .then(r => (r.ok ? r.json() : null))
      .then(d => { if (alive) setSummary(d && d.success ? d : null); })
      .catch(() => { if (alive) setSummary(null); });
    return () => { alive = false; };
  }, [opportunityId, refreshKey]);

  if (!summary || !summary.mixed) return null;
  const names = (summary.pricebooks || []).map(p => p.name).join(' · ');
  return (
    <div dir="rtl" role="status" style={{
      background: '#fff4e5', border: '1px solid #ffb74d', color: '#8a5300',
      borderRadius: 8, padding: '8px 12px', marginBottom: 8, fontSize: 13,
    }}>
      ⚠️ <b>הזדמנות מעורבת</b> — יש בה מוצרים מכמה מחירונים: {names}.
      {' '}החרגה מוולידציה שמוגבלת למחירון לא חלה על הזדמנות כזו.
    </div>
  );
}
